import { Component } from '@angular/core';
import { diegoRoutes } from '@core/enums/orderflow-paths';
import { IconNames } from '@shared/enums/icon-names';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { IceCardComponent } from '@app/shared/components/atoms/ice-card/ice-card.component';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss'],
  imports: [IceCardComponent, MatIcon, RouterLink],
})
export class PagenotfoundComponent {
  IconNames = IconNames;
  diegoRoutes = diegoRoutes;
}
